import type {
  LogistikCartItem,
  LogistikChancenBriefCartItem,
  LogistikLearningMaterialCartItem,
  LogistikWorkshoppackCartiItem,
} from '@chancenwerk/db/LogistikCart.js';
import {
  LogistikLearningMaterialOrderItem,
  LogistikOrder,
  LogistikOrderChancenBriefItem,
  LogistikOrderItem,
  LogistikWorkshopPackOrderItem,
  ProductSetOrderItem,
  type LogistikOrderShippingDetails,
} from '@chancenwerk/db/LogistikOrder.js';
import {
  ChancenBrief,
  LearningMaterial,
  LogistikProductSet,
  TravelCertificate,
  WorkshopPack,
} from '@chancenwerk/db/LogistikProduct.js';
import { LogistikOrderAPI } from '@chancenwerk/db/api/LogistikOrderAPI.js';
import { LogistikProductCategory } from '@chancenwerk/db/enums/LogistikEnums.js';
import type { DateTime } from 'luxon';

export const placeOrder = async (
  cartItems: Array<LogistikCartItem | LogistikLearningMaterialCartItem | LogistikWorkshoppackCartiItem>,
  shippingDetails: LogistikOrderShippingDetails,
  {
    isExpress = false,
    token,
    isManual,
    orderDate,
    studentCount,
  }: { isExpress?: boolean; token?: number; isManual?: boolean; orderDate?: DateTime; studentCount?: number },
) => {
  const order = new LogistikOrder({
    shippingDetails,
    isExpress,
    studentCount,
    isManuallyCreated: isManual,
    ...(token ? { accessToken: token } : {}),
    ...(orderDate ? { createdAt: orderDate } : {}),
    items: cartItems.map(item => {
      switch (item.productCategory as string) {
        case LogistikProductCategory.WORKSHOP_PACK:
        case WorkshopPack._class:
          return new LogistikWorkshopPackOrderItem({
            productID: item.productID,
            quantity: item.quantity,
            participantsQuantity: (item as LogistikWorkshoppackCartiItem).participantsQuantity,
            trainersQuantity: (item as LogistikWorkshoppackCartiItem).trainersQuantity,
            productCategory: item.productCategory,
          });
        case LogistikProductCategory.LEARNING_MATERIAL:
        case LearningMaterial._class:
          return new LogistikLearningMaterialOrderItem({
            productID: item.productID,
            quantity: item.quantity,
            productCategory: item.productCategory,
            flyaVariableValues: item.flyaVariableValues,
            isDigital: (item as LogistikLearningMaterialCartItem).isDigital,
          });
        case LogistikProductCategory.CHANCEN_BRIEF:
        case ChancenBrief._class:
          return new LogistikOrderChancenBriefItem({
            productID: item.productID,
            quantity: item.quantity,
            productCategory: item.productCategory,
            flyaVariableValues: item.flyaVariableValues,
            isSelfPrint: (item as LogistikChancenBriefCartItem).isSelfPrint,
          });
        case LogistikProductCategory.TRAVEL_CERTIFICATE:
        case TravelCertificate._class:
          return new LogistikOrderChancenBriefItem({
            productID: item.productID,
            quantity: item.quantity,
            productCategory: item.productCategory,
            flyaVariableValues: item.flyaVariableValues,
            isSelfPrint: (item as LogistikChancenBriefCartItem).isSelfPrint,
          });
        case LogistikProductCategory.SET:
        case LogistikProductSet._class:
          return new ProductSetOrderItem({
            productID: item.productID,
            quantity: item.quantity,
            flyaVariableValues: item.flyaVariableValues,
          });
        default:
          return new LogistikOrderItem({
            productID: item.productID,
            quantity: item.quantity,
            productCategory: item.productCategory,
          });
      }
    }),
  });

  await LogistikOrderAPI.placeOrder(order)();
};
